module.exports = __webpack_public_path__ + "img/reorder-old-icon.e84b8085.svg";